/*
 * @Description: 
 * @Autor: fzw
 * @Date: 2024-08-05 10:27:11
 * @LastEditTime: 2024-08-22 15:09:33
 */
import { ElTooltip } from 'element-plus';
import { createApp, nextTick } from 'vue';
/**
 * 判断文本是否溢出
 */
function isTextOverflowing (element) {
    return element.scrollWidth > element.offsetWidth;
}

/**
 * 创建tooltip，这里采用element-plus的tooltip组件
 * 使用案例：
 * <span v-text-tootip:auto>xxxxxxx</span> tooltip 自定判断文本是否溢出，溢出了鼠标悬浮才会展示tooltip
 * <span v-text-tootip>xxxxxxx</span> tooltip 直接悬浮展示tooltip
 * @param el
 * @param binding
 */
const createTooltip = (el, binding) => {
    const arg = binding.arg
    const isShow = arg === 'auto' ? isTextOverflowing(el) : true
    if (isShow) {
        const id = '_tooltip_root_' + Math.random().toString(36).slice(2, 10)
        // 移除旧的
        if (el._tipapp) {
            el._tipapp.unmount();
            el._tipapp = null;
        }
        if (el._tiproot && el._tiproot.parentNode) {
            el._tiproot.parentNode.removeChild(el._tiproot)
        }
        el._tiproot = document.createElement('div')
        el._tiproot.id = id
        el._tipapp = createApp(ElTooltip, {
            trigger: 'hover',
            virtualRef: el,
            rawContent: true,
            placement: 'top',
            virtualTriggering: true,
            content: el.innerText || el.innerHTML
        })
        document.body.appendChild(el._tiproot)
        el._tipapp.mount('#' + id)
    } else {
        // 销毁组件实例和 DOM
        if (el._tipapp) {
            el._tipapp.unmount();
            el._tipapp = null;
        }
        if (el._tiproot && el._tiproot.parentNode) {
            el._tiproot.parentNode.removeChild(el._tiproot)
            el._tiproot = null
        }
    }
}

/**
 * 文本溢出则显示省略号并悬浮鼠标展示tooltip
 */
export default {
    install (Vue) {
        Vue.directive('textTootip', {
            mounted (el, binding) {
                el.style.whiteSpace = 'nowrap'
                el.style.overflow = 'hidden'
                el.style.textOverflow = 'ellipsis'
                createTooltip(el, binding)
                el._tipObserver = new MutationObserver(() => {
                    nextTick(() => {
                        createTooltip(el, binding)
                    });
                });
                el._tipObserver.observe(el, { childList: true, characterData: true, subtree: true });
            },
            updated (el, binding) {
                nextTick(() => {
                    createTooltip(el, binding)
                });
            },
            unmounted (el) {
                if (el._tipObserver) el._tipObserver.disconnect();
                if (el._tipapp) el._tipapp.unmount();
                if (el._tiproot && el._tiproot.parentNode) {
                    el._tiproot.parentNode.removeChild(el._tiproot)
                }
                el._tipapp = null;
                el._tiproot = null;
            }
        });
    },
};